export default "__VITE_PUBLIC_ASSET__e3ae658a__"